import styled, { css } from 'styled-components';
import { SECONDARY_COLOR_5, SECONDARY_COLOR } from '../../const/color';
import { FAMILY_FONT_PRIMARY, TITLE_SIZE_5 } from '../../const/text';
import { CloseIcon, DropIcon } from '../../const/icons';
import { isHexColorDark } from '../../utils/Color';
import { device } from '../../const/device';

export const Container = styled.div`
  position: relative;
  padding: 11px 16px 15px 15px;
  border: 1px solid ${SECONDARY_COLOR_5};
  border-radius: 8px;
  margin-top: 15px;
  overflow-y: hidden;
  overflow-x:auto;
  
  @media (${device.tablet}) {
    border: none;
    padding: 0;
    margin-top: 0;
  }
  @media (${device.mobileL}) {
    flex: 1 1 auto;
  }

  &::-webkit-scrollbar {
    height:3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background:${SECONDARY_COLOR};
  }
`;
export const Title = styled.div`
  font-family: ${FAMILY_FONT_PRIMARY};
  font-size: ${TITLE_SIZE_5}px;
  text-transform: uppercase;
  margin-bottom: 11px;
  
  @media (${device.tablet}) {
    display: none;
  }
`;
export const List = styled.div`
  width: 384px;
  height: 72px;
  border-radius: 4px;
  display: flex;

  
  @media (${device.tablet}) {
    height: 208px;
    width: 100%;
  }
  @media (${device.mobileL}) {
    height: 100px;
    width: 100%;
  }
`;
export const Item = styled.div<{ color: string, active: boolean }>`
  height: 100%;
  width: 40px;
  flex: 1 1 auto;
  cursor: pointer;
  background-color: ${props => props.color};
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 14px;
    height: 14px;
    background: url("data:image/svg+xml,${props => DropIcon(isHexColorDark(props.color))}") center / auto 100% no-repeat;
    pointer-events: none;
    display: none;
  }
  &:hover:after {
    display: block;
  }
  ${props => props.active ? css`
    &:after {
      display: block;
    }
  ` : ''}
  
`;
export const Button = styled.div`
  position: absolute;
  width: 12px;
  height: 12px;
  background: url("data:image/svg+xml,${CloseIcon()}") center / contain no-repeat;
  top: 13px;
  right: 17px;
  cursor: pointer;
  
  @media (${device.tablet}) {
    display: none;
  }
`;
